<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-md-6">
                        <h5 class="set_font_title">Dewormings</h5>
                    </div>
                    <div class="col-md-6">
                        <div class="add-drugs-animals-button">
                            <button
                                type="button"
                                class="btn btn-success btn-round"
                                @click="showAddDewormingModal"
                            >
                                Add Deworming
                            </button>
                        </div>
                    </div>
                </div>

                <hr>

                <div class="row">
                    <div class="col-12">
                        <p>Add Deworming the organization intends to use on various projects. This will be used in
                            the application later when records are created to record what dewormings were
                            administrated.</p>
                    </div>
                </div>

                <div class="row" v-for="(item, index) in dewormingData" :key="index">
                    <div class="col-md-10 col-sm-6">
                        <p class="animal_name">{{ item.deworming_name }}</p>
                    </div>
                    <template>
                        <div class="col-md-2 col-sm-6 icon-main">
                            <span
                                class="ti-pencil icon-pencil"
                                @click="updateDeworming(item)"
                            ></span>
                            <span
                                class="ti-trash icon-trash"
                                @click="deleteDeworming(item.id)"
                            ></span>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div v-if="editDewormingModal" class="modal animal-modal fade" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content animle-modal-content">
                    <div class="modal-header animal-header">
                        <h4 class="modal-title">Edit Deworming</h4>
                    </div>
                    <div class="modal-body animal-modal-body">
                        <div class="form-group row animal-row">
                            <label>Deworming Name</label><br/>
                            <input
                                class="form-control col-sm-12"
                                type="text"
                                name="animal-name"
                                v-model="deworming_name"
                            />
                            <br/>
                            <p>
                                (Note: This will make new Deworming visible to entire
                                organisation)
                            </p>
                        </div>
                    </div>
                    <div class="animal-footer">
                        <button
                            type="button"
                            class="btn btn-default"
                            style="background-color: var(--hw-danger) !important;"
                            data-dismiss="modal"
                            @click="hideEditDewormingModal"
                        >
                            Close
                        </button>
                        <button
                            v-bind:disabled="!onLine"
                            type="button"
                            class="btn btn-default"
                            style="background-color: var(--hw-pair1-secondary) !important;"
                            data-dismiss="modal"
                            @click="editDeworming"
                        >
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="addDewormingModal" class="modal animal-modal fade" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content animle-modal-content">
                    <div class="modal-header animal-header">
                        <h4 class="modal-title">Add Deworming</h4>
                    </div>
                    <div class="modal-body animal-modal-body">
                        <div class="form-group row animal-row">
                            <label>Deworming Name</label><br/>
                            <input
                                class="form-control col-sm-12"
                                type="text"
                                name="animal-name"
                                v-model="add_deworming_name"
                            />
                            <br/>
                            <p>
                                (Note: This will make new Deworming visible to entire
                                organisation)
                            </p>
                        </div>
                    </div>
                    <div class="animal-footer">
                        <button
                            type="button"
                            class="btn btn-default"
                            style="background-color: var(--hw-danger) !important;"
                            data-dismiss="modal"
                            @click="hideDewormingModal"
                        >
                            Close
                        </button>
                        <button
                            type="button"
                            class="btn btn-default"
                            style="background-color: var(--hw-pair1-secondary) !important;"
                            data-dismiss="modal"
                            @click="addDeworming"
                        >
                            Add
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <help-modal ref="helpModal"></help-modal>
    </div>
</template>
<script>
import {mapGetters} from "vuex";

import mixin from "../../mixins/GlobalMixin";
import Swal from "sweetalert2"

export default {
    components: {},
    data: function () {
        return {
            dewormingModal: false,
            editDewormingModal: false,
            dewormingData: [],
            deworming_name: "",
            dewormingId: "",
            addDewormingModal: false,
            add_deworming_name: "",
        };
    },
    mixins: [mixin],
    methods: {
        showAddDewormingModal() {
            this.addDewormingModal = true;
        },
        hideDewormingModal() {
            this.addDewormingModal = false;
        },
        hideEditDewormingModal() {
            this.editDewormingModal = false;
        },
        addDeworming() {
            var vm = this;
            window.axios
                .post(
                    "/deworming/add?deworming_name=" +
                    vm.add_deworming_name +
                    "&organisation_id=" +
                    vm.organisationId
                )
                .then((response) => {
                    if (response.data.response.error.error_code == 0) {
                        vm.showAlert("Success", response.data.response.error.msg, true);
                        vm.getDewormings(vm.organisationId);
                        vm.add_deworming_name = ''
                        this.addDewormingModal = false;
                    }
                })
                .catch((error) => {
                    console.log(error)
                });
        },
        async getDewormings(id) {
            var vm = this;
            await vm.$store.dispatch('getOrgDeworming', id);
            vm.dewormingData = vm.$store.getters.getDeworming;
        },
        updateDeworming(data) {
            this.editDewormingModal = true;
            this.deworming_name = data.deworming_name;
            this.dewormingId = data.id;
        },
        deleteDeworming(dewormingId) {
            let vm = this;
            new Swal({
                title: "Alert!",
                text: "Are you sure you want to delete this deworming? ",
                type: "warning",
                icon: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success btn-fill",
                cancelButtonClass: "btn btn-danger btn-fill",
                confirmButtonText: "yes",
                buttonsStyling: false,
            }).then(function (result) {
                if (result.value) {
                    window.axios
                        .delete(
                            "/deworming/remove/" +
                            vm.organisationId +
                            "?deworming_id=" +
                            dewormingId
                        )
                        .then((response) => {
                            if (response.data.response.error.error_code == 0) {
                                vm.showAlert("Success", response.data.response.error.msg, true);
                                vm.getDewormings(vm.organisationId);
                            } else {
                                alert(response.data.response.error.error_msg)
                            }
                        })
                        .catch((error) => {
                            vm.showAlert(
                                "Error",
                                error.response.data.response.error.error_msg,
                                false
                            );
                        });
                }
            });
        },
        editDeworming() {
            var vm = this;
            window.axios
                .put(
                    "/deworming/edit/" +
                    vm.organisationId +
                    "?deworming_id=" +
                    vm.dewormingId +
                    "&edited_deworming_name=" +
                    vm.deworming_name
                )
                .then((response) => {
                    if (response.data.response.error.error_code == 0) {
                        vm.showAlert("Success", response.data.response.error.msg, true);
                        vm.getDewormings(vm.organisationId);
                        vm.editDewormingModal = false;
                        vm.deworming_name=''
                    }
                })
                .catch((error) => {
                    console.log(error)
                });
        },
        showUrl() {
            this.$refs.helpModal.loadUrl(window.USER_MANUAL_URL + "#h.bswdx03ab2pw");
        },
    },
    computed: {
        ...mapGetters("user", ["organisation"]),
    },
    mounted() {
        const vm = this;
        vm.organisationId = this.organisation.id;
        this.getDewormings(vm.organisationId);
    },
};
</script>
<style scoped>
.card-body {
    text-align: left !important;
}

a {
    color: white;
}

.a_color {
    color: black !important;
}

/* Pradeep Start */
@media (min-width: 320px) {
    .set_row {
        margin-right: 0px !important;
        margin-left: 0px !important;
    }
}

/* Pradeep end */
.set_font_title {
    margin-top: 15px;
    padding-left: 10px;
    font-size: 20px;
    font-weight: 600;
    color: black;
}

.animal_name {
    margin-top: 5px !important;
    text-align: left;
}

.icon-main {
    margin-top: 5px !important;
    text-align: right;
}

.icon-pencil {
    cursor: pointer;
}

.icon-trash {
    cursor: pointer;
    margin-left: 10px;
}

.modal-footer {
    border-top: 1px solid #dddddd;
    padding: 10px !important;
}

.modal-title {
    margin-bottom: 0 !important;
    margin-top: 0 !important;
}

.animal-footer {
    text-align: right;
    margin-right: 4%;
    margin-bottom: 1%;
}

.add-drugs-animals-button {
    text-align: left;
    float: right;
    /* margin-left: 12px; */
}

.animal-modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    width: 100%;
    padding: 80px;
    height: 100%;
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.66); /* Black w/ opacity */
    display: block;
    opacity: 1 !important;
}

@media (max-width: 767px) {
    .animal-modal {
        padding: 0;
    }

    .modal-title {
        font-size: 1.4em;
    }

    .modal-body {
        padding: 20px 30px;
    }
}

.animal-modal-body {
    color: #000;
}
</style>
